import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { Device, DeviceCreate, DeviceUpdate } from '../types/api.types'

export const devicesService = {
  async getAll(propertyId?: number, communicationMode?: string): Promise<Device[]> {
    const params = new URLSearchParams()
    if (propertyId) params.append('property_id', propertyId.toString())
    if (communicationMode) params.append('communication_mode', communicationMode)
    const query = params.toString()
    const url = query ? `${API_ENDPOINTS.DEVICES}?${query}` : API_ENDPOINTS.DEVICES
    const { data } = await axiosInstance.get<Device[]>(url)
    return data
  },

  async getById(id: number): Promise<Device | null> {
    try {
      const { data } = await axiosInstance.get<Device>(API_ENDPOINTS.DEVICE_BY_ID(id))
      return data
    } catch {
      return null
    }
  },

  async create(device: DeviceCreate): Promise<Device> {
    const { data } = await axiosInstance.post<Device>(API_ENDPOINTS.DEVICES, device)
    return data
  },

  async update(id: number, device: DeviceUpdate): Promise<Device> {
    const { data } = await axiosInstance.put<Device>(API_ENDPOINTS.DEVICE_BY_ID(id), device)
    return data
  },

  async delete(id: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.DEVICE_BY_ID(id))
  },
}
